import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TripistEmbedService {
  private loaded = false;
  private loading: Promise<void> | null = null;

  get tripistEnvironment(): string {
    return environment.tripistEnvironment;
  }

  loadScript(): Promise<void> {
    if (this.loaded) {
      return Promise.resolve();
    }

    if (this.loading) {
      return this.loading;
    }

    this.loading = new Promise<void>((resolve, reject) => {
      const scriptUrl = environment.tripistEnvironment === 'dev'
        ? `${environment.tripistScriptUrl}?_t=${Date.now()}`
        : environment.tripistScriptUrl;

      const script = document.createElement('script');
      script.src = scriptUrl;
      script.onload = () => {
        this.loaded = true;
        this.loading = null;
        resolve();
      };
      script.onerror = (e) => {
        this.loading = null;
        reject(e);
      };
      document.head.appendChild(script);
    });

    return this.loading;
  }
}
